import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getPhysioServiceSlice } from "../../../../store/slices/physioserviceSlice";
import { getAllPhysician } from "../../../../store/slices/physicianSlice";
import { useSelector, useDispatch } from "react-redux";

const Physiotherapy = ({
  handleChange,
  isClient,
  numberOfSessions,
  appDate,
  formData,
  setFormData,
}) => {
  const [totalAmount, setTotalAmount] = useState(0);
  const [endDate, setEndDate] = useState("");
  const [selectedServices, setSelectedServices] = useState([]);
  const [rawSelectedOptions, setRawSelectedOptions] = useState([]);
  const dispatch = useDispatch();
  const { physiotherapyServices } = useSelector(
    (state) => state.physiotherapyService
  );
  const { physician } = useSelector((state) => state.physician);
  const { token } = useSelector((state) => state.auth);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const clinicId = clinicInfo?.[0]?.clinicId || null;
  useEffect(() => {
    dispatch(
      getPhysioServiceSlice({
        token,
        status: ["Active"],
        clinicId,
      })
    );
    dispatch(
      getAllPhysician({
        clinicId,
        clinicStatus: "Accepted",
        physicianStatus: "Accepted",
        token,
      })
    );
  }, [dispatch, token, clinicId]);

  useEffect(() => {
    const calculateTotalAmount = () => {
      const total = selectedServices.reduce(
        (sum, service) => sum + (service.price || 0),
        0
      );
      const sessionCount = parseInt(numberOfSessions, 10) || 1;
      return total * sessionCount;
    };

    const calculateEndDate = () => {
      if (appDate && !isNaN(Date.parse(appDate)) && numberOfSessions > 0) {
        const appStartDate = new Date(appDate);
        const end = new Date(appStartDate);
        end.setDate(
          appStartDate.getDate() + parseInt(numberOfSessions, 10) - 1
        );
        return end.toISOString().split("T")[0];
      }
      return "";
    };

    setTotalAmount(calculateTotalAmount());
    setEndDate(calculateEndDate());
  }, [
    selectedServices,
    numberOfSessions,
    appDate,
    physiotherapyServices,
    isClient,
  ]);

  const handleSelectedPhysioTherapyService = (selectedOptions) => {
    setRawSelectedOptions(selectedOptions || []); // ✅ always array

    const selectedWithPrice = (selectedOptions || []).map((option) => ({
      id: option.value,
      name: option.label,
      price: option.price * (numberOfSessions || 1),
      type: option.type,
    }));

    setSelectedServices(selectedWithPrice);
    handleChange(selectedWithPrice, "serviceDetails");
  };

  const handleSessionCountChange = (e) => {
    handleChange(
      { target: { name: "numberOfSessions", value: e.target.value } },
      "numberOfSessions"
    );
  };

  useEffect(() => {
  if (!rawSelectedOptions.length) return;

  const updated = rawSelectedOptions.map((option) => {
    const matched =
      physiotherapyServices?.find((s) => s._id === option.value);

    const updatedPrice =
      isClient === "Yes"
        ? matched?.client_price ?? matched?.pt_price ?? 0
        : matched?.pt_price ?? 0;

    return {
      ...option,
      price: updatedPrice,
    };
  });

  setRawSelectedOptions(updated);

  const updatedWithQty = updated.map((option) => ({
    id: option.value,
    name: option.label,
    price: option.price * (numberOfSessions || 1),
    type: option.type,
  }));

  setSelectedServices(updatedWithQty);
  handleChange(updatedWithQty, "serviceDetails");
}, [isClient]);

  const physiotherapists = physician?.filter((physicianItem) =>
    physicianItem?.specialization?.some(
      (specialization) =>
        specialization?.specialization?.trim().toLowerCase() ===
        "physiotherapist"
    )
  );

  return (
    <>
      <div className="col-xl-6">
        <div className="form-group">
          <label htmlFor="name" className="col-form-label">
            Service Details:
          </label>
          <Select
            options={physiotherapyServices?.map((service) => ({
              value: service?._id || service?.id,
              label: service?.serviceDetailName,
              price:
                isClient === "Yes"
                  ? service?.client_price ?? service?.pt_price ?? 0
                  : service?.pt_price ?? 0,
              type: "physiotherapy",
            }))}
            value={rawSelectedOptions || []} // ✅ force array
            onChange={handleSelectedPhysioTherapyService}
            isMulti
          />
        </div>
      </div>
      <div className="col-xl-6">
        <div className="form-group">
          <label htmlFor="numberOfSessions" className="col-form-label">
            Number of Sessions *
          </label>
          <input
            type="number"
            className="form-control"
            id="numberOfSessions"
            placeholder="Number of Sessions"
            name="numberOfSessions"
            value={numberOfSessions}
            onChange={handleSessionCountChange}
          />
        </div>
      </div>
      <div className="col-xl-6"> 
        <div className="form-group">
          <label htmlFor="physician" className="col-form-label">
            Consulting Physician:
          </label>
          <Select
            inputId="physician"
            options={physiotherapists?.map((physicianItem) => ({
              value: physicianItem?._id,
              label: physicianItem?.userId?.name,
            }))}
            onChange={(selectedPhysician) =>
              handleChange(selectedPhysician, "physician")
            }          />
        </div>
      </div>
      <div className="col-xl-6">
        <div className="form-group">
          <label htmlFor="endDate" className="col-form-label">
            End Date
          </label>
          <input
            type="date"
            className="form-control"
            id="endDate"
            name="endDate"
            value={endDate}
            readOnly
          />
        </div>
      </div>
      <div className="col-xl-6">
        <div className="form-group">
          <label htmlFor="totalAmount" className="col-form-label">
            Total Amount:
          </label>
          <input
            type="number"
            className="form-control"
            id="totalAmount"
            value={totalAmount}
            readOnly
          />
        </div>
      </div>
    </>
  );
};

export default Physiotherapy;
